import React from 'react';
import { ArtifactTreeManager } from './ArtifactTreeManager';

export const ArtifactTreeManagerPage: React.FC = () => {
  return <ArtifactTreeManager />;
};

